import type { ComponentProps, MouseEvent, PropsWithChildren } from "react";

import { styled } from "styled-components";

import { BorderCard } from "../styledComponents";

import { ViewMoreOverlay } from "./ViewMoreOverlay";

const StyledBorderCard = styled(BorderCard)`
    &:hover {
        > div[data-overlay] {
            opacity: 1;
        }
    }
`;

type BorderCardProps = ComponentProps<typeof StyledBorderCard>;

type PreviewCardProps = BorderCardProps & {
    onClick?: () => void;
};

export const PreviewCard = ({ onClick, children, ...other }: PropsWithChildren<PreviewCardProps>) => {
    const handleCardClick = (event: MouseEvent) => {
        event.stopPropagation();
        onClick?.();
    };

    return (
        <StyledBorderCard
            {...other}
            onClick={handleCardClick}
        >
            <ViewMoreOverlay onClick={onClick} />
            {children}
        </StyledBorderCard>
    );
};
